/**
 * Replaces the Property IDs in the raw expression text with their corresponding field names.
 * @param {String} rawExpression - The raw expression text.
 */
export function displayExpression (rawExpression){
    // Call the utility function to replace field IDs with names..PW
    return app.dv.tools.showExpressionFieldsAsNames(rawExpression);
}
